/** @format */
import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { OtmId } from 'common-typescript/types';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocaleService } from 'sis-common';
import { OpenUniversityPaymentSystemService } from 'sis-components';
import { OpenUniversityErrorHelperService } from '../../../service/open-university-error-helper.service';

@Component({
    selector: 'app-monetary-payment-failed',
    standalone: false,
    templateUrl: './monetary-payment-failed.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonetaryPaymentFailedComponent {
    private readonly localeService = inject(LocaleService);
    private readonly openUniversityErrorHelper = inject(OpenUniversityErrorHelperService);
    private readonly openUniversityPaymentSystemService = inject(OpenUniversityPaymentSystemService);

    protected readonly requestInProgress = signal<boolean>(false);

    protected retryPayment(cartId: OtmId): void {
        if (this.requestInProgress()) {
            return;
        }

        this.requestInProgress.set(true);
        this.openUniversityPaymentSystemService
            .initializePaymentAndNavigateToPaymentSystem(cartId, this.localeService.getCurrentLanguage(), null)
            .pipe(
                catchError(() => {
                    this.openUniversityErrorHelper.showPaymentInitializationFailureAlert();
                    return EMPTY;
                }),
            )
            .subscribe()
            .add(() => {
                this.requestInProgress.set(false);
            });
    }
}
